import { render, staticRenderFns } from "./adInfoConfig.vue?vue&type=template&id=801c2dfe&scoped=true"
import script from "./adInfoConfig.vue?vue&type=script&lang=js"
export * from "./adInfoConfig.vue?vue&type=script&lang=js"
import style0 from "./adInfoConfig.vue?vue&type=style&index=0&id=801c2dfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801c2dfe",
  null
  
)

export default component.exports